//LastModifier
//***********************************************************************************************************************
import * as React from "react";

export interface IFormGroupProp {
    changeButton?: React.ReactNode;
    label?: string;
    required?: boolean;
    white?: boolean;
}

export const FormGroup = (props: React.PropsWithChildren<IFormGroupProp>) => {
    return (
        <div className={"form-group" + (props.required ? " required" : "") + (props.changeButton ? " flexField" : "") + (props.white ? " roWhite" : "")}>
            {!props.changeButton &&
                <React.Fragment>
                    {!!props.label &&
                        <label className="control-label">{props.label}</label>
                    }
                    {props.children}
                </React.Fragment>
            }
            {!!props.changeButton &&
                <React.Fragment>
                    <div className="grow">
                        <label className="control-label">{props.label}</label>
                        {props.children}
                    </div>
                    <div className="right">
                        {props.changeButton}
                    </div>
                </React.Fragment>
            }
        </div>
    );
};
